export const generateComponentDetail: (
    params: {
        name: string;
        innerName: string;
        properties: {
            name: string;
            innerName: string;
            value: string;
            displayValue: string;
            valueType: number;
        }[];
    }[]
) => { key: string; value: string }[] = components => {
    const allProperties = components.map(v => v.properties).flat();
    const details = allProperties
        .map(v => ({
            key: v.innerName,
            value: v.displayValue
        }))
        .filter(v => v.value);
    return details;
};
